import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import Client from './components/Client';
import News from './components/News';
import NewsFilters from './components/NewsFilters';
import Visibility from './Visibility';

export default class NewsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client('none'),
      news: null,
      addNew: false,
      filterData: undefined,
    };

    this.applyFilters = this.applyFilters.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.newsUpdated = this.newsUpdated.bind(this);
    this.getData = this.getData.bind(this);

    this.restricted = new Visibility('news');
    this.filtersRef = React.createRef();
  }

  componentDidMount() {
    if (this.restricted.scope.visible) this.getData();
  }

  /**
   * Base load: no filters, just latest news.
   * Backend should handle pin_position + modifiedOn ordering.
   */
  getData() {
    // 👇 switched from orderBy_createdOn to orderBy_modifiedOn
    const queryData = { limit: 20, orderBy_modifiedOn: true };

    const data = this.state.client.getData(
      (this.props.API_URL_NEWS || '/api/1.0/news/'),
      queryData
    );

    if (data && data.news) this.setState({ news: data.news });
    else if (data && Array.isArray(data)) this.setState({ news: data });
  }

  /**
   * Called by NewsFilters when user applies filters.
   * We enforce orderBy_modifiedOn by default, but allow filters
   * to add other params.
   */
  applyFilters(queryData) {
    const base = (this.props.API_URL_NEWS || '/api/1.0/news/');

    // 👇 ensure sorting by modifiedOn unless caller explicitly overrides
    const enriched = {
      orderBy_modifiedOn: true,
      ...queryData,
    };

    const data = this.state.client.getData(base, enriched);
    if (data) {
      this.setState({
        news: data.news || data,
        filterData: enriched,   // 👈 remember last filters + sort
      });
    }
  }

  toggleAdd() {
    if (!this.restricted.scope.edit) return;
    this.setState((s) => ({ addNew: !s.addNew }));
    window.scrollTo(0, 0);
  }

  /**
   * Called by each <News /> after save.
   * We:
   *  - Close the "addNew" editor
   *  - Reload data
   *  - Respect current filters if any
   */
  newsUpdated() {
    const queryData = this.state.filterData;  // may be undefined

    this.setState({ news: null, addNew: false }, () => {
      if (queryData) {
        // If user has filters, re-apply them (with orderBy_modifiedOn)
        this.applyFilters(queryData);
      } else {
        // Otherwise, just reload base list
        this.getData();
      }
      window.scrollTo(0, 0);
    });

    // reset +/– button in NewsFilters
    if (this.filtersRef?.current) {
      this.filtersRef.current.setState({ addNew: false });
    }
  }

  render() {
    if (!this.restricted.scope.visible) return <div />;

    let list = null;
    let counter = 0;

    if (this.state.news) {
      counter = this.state.news.length;
      list = this.state.news.map((item) => (
        <News
          key={item.iref}
          item={item}
          onUpdated={this.newsUpdated}
          allowEdit={this.restricted.scope.edit}
          API_URL_NEWS={this.props.API_URL_NEWS}
          API_URL_LANGUAGE={this.props.API_URL_LANGUAGE}
          API_URL_COUNTY={this.props.API_URL_COUNTY}
        />
      ));
    }

    return (
      <div style={{ backgroundColor: '#273442', minHeight: '100%' }}>
        <div className="sticky">
          <NewsFilters
            ref={this.filtersRef}
            applyFilters={this.applyFilters}
            toggleAdd={this.toggleAdd}
            counter={counter}
            allowEdit={this.restricted.scope.edit}
          />
        </div>

        {this.state.addNew ? (
          <News
            key={0}
            item={undefined}
            isNew={true}
            onUpdated={this.newsUpdated}
            allowEdit={this.restricted.scope.edit}
            API_URL_NEWS={this.props.API_URL_NEWS}
            API_URL_LANGUAGE={this.props.API_URL_LANGUAGE}
            API_URL_COUNTY={this.props.API_URL_COUNTY}
          />
        ) : null}

        {!this.state.news ? (
          <Box sx={{ p: 2 }}>
            <Skeleton animation="wave" variant="rounded" width={800} height={180} />
            <Skeleton animation="wave" variant="rounded" width={800} height={180} sx={{ mt: 1 }} />
          </Box>
        ) : (
          list
        )}
      </div>
    );
  }
}